import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=0a613d7e&scoped=true&"
import script from "./feature.vue?vue&type=script&lang=js&"
export * from "./feature.vue?vue&type=script&lang=js&"
import style0 from "./feature.vue?vue&type=style&index=0&id=0a613d7e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a613d7e",
  null
  
)

export default component.exports